<template>
  <div class="containers">
    <!-- 更改浏览器标题 -->
    <!-- <div class="main" v-title data-title="首页">
    </div> -->
    <!-- 轮播 -->
    <!-- <Swiper></Swiper> -->
    <div class="max">
      <div class="choice">
        <ul>
          <li @click="nums(1)">
            <img v-if="num == 1" src="../assets/imgs/新闻页/05.png" alt="" />
            <img v-else src="../assets/imgs/新闻页/01.png" alt="" />
          </li>
          <li @click="nums(2)">
            <img v-if="num == 2" src="../assets/imgs/新闻页/06.png" alt="" />
            <img v-else src="../assets/imgs/新闻页/02.png" alt="" />
          </li>
          <!-- <li @click="nums(3)">
            <img v-if="num == 3" src="../assets/imgs/新闻页/07.png" alt="" />
            <img v-else src="../assets/imgs/新闻页/03.png" alt="" />
          </li>
          <li @click="nums(4)">
            <img v-if="num == 4" src="../assets/imgs/新闻页/08.png" alt="" />
            <img v-else src="../assets/imgs/新闻页/04.png" alt="" />
          </li> -->
        </ul>
      </div>
      <div class="main">
        <p class="null" v-if="!newslist.length">{{ $t('home.2-1') }}</p>
        <ul>
          <li v-for="(item,index) in newslist" :key="item.id" @click="details(item,index)">
            <div class="liL">
              <img :src="item.coverImg" alt="" />
            </div>
            <div class="liR" >
              <h4>{{ item.title }}</h4>
              <p v-html="item.content"></p>
              <p class="time">{{ FormatTime(item.addDate) }}</p>
            </div>
          </li>
        </ul>
        <el-pagination background  layout="prev, pager, next" :total="total" @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
// import Swiper from './components/swiper.vue'
import { newList } from '@/api/index.js'
// import { WOW } from 'wowjs'
export default {
  data() {
    return {
      newslist: [],
      total: null,
      num: 1,
      pageNum: 1,
      pageSize: 10,
      lang: '',
      type: 1
    }
  },
  components: {
    // Swiper
  },
  mounted() {
    this.new()
    this.$bus.$on('lang', (lang) => {
      this.type = lang
      this.new()
    })
  },
  methods: {
    details(i, index) {
      // this.$router.push('/newDetails')
      this.$router.push({
        path: '/newDetails',
        query: {
          code: i.id,
          sort: index
        }
      })
    },
    async new() {
      setTimeout(async () => {
        if (this.$i18n.locale === 'zh') {
          this.type = 1
        } else {
          this.type = 2
        }
        if (this.type === 'zh' || this.type === 1) {
          this.type = 1
        } else {
          this.type = 2
        }
        const { data } = await newList({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          newsType: this.num,
          language: this.type
        })
        this.newslist = data.list
        this.total = data.total
      })
    },
    jian() {
      this.pageNum--
      if (this.pageNum > 0) {
        this.new()
      } else {
      }
    },
    async jia() {
      this.pageNum++
      const { data } = await newList({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        newsType: this.num
      })
      console.log(data)
      if (data.newsList.length > 0) {
        this.newslist = data.newsList
      } else {
        this.$message.warning('暂无更多')
      }
    },
    nums(a) {
      this.num = a
      this.new()
    },
    FormatTime(time) {
      if (time) {
        var date = new Date(time)
        var YY = date.getFullYear() + '-'
        var MM =
          (date.getMonth() + 1 < 10
            ? '0' + (date.getMonth() + 1)
            : date.getMonth() + 1) + '-'
        var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
        // var hh =
        //   (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
        // var mm =
        //   (date.getMinutes() < 10
        //     ? '0' + date.getMinutes()
        //     : date.getMinutes()) + ':'
        // var ss =
        //   date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
        return YY + MM + DD
        // + ' ' + hh + mm + ss
      }
    },
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum
      this.new()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.new()
    }
  }
}
</script>
<style lang="less" scoped>
.containers {
  box-sizing: border-box;
  min-width: 1200px;
  padding-top: 120px;
  background-color: #112945;
  // background: linear-gradient(to right, #6495ED 0%,#112945  20%, #112945  50%,#112945  85%, #6495ED 100%);
  padding-bottom: 250px;
  @media screen and (max-width: 1200px) {
    padding-top: 200px;
  }

  /deep/.today .cell {
    color: rgb(255, 255, 255) !important;
    font-weight: 500 !important;
  }
  .max {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .choice {
      ul {
        li {
          margin-top: 20px;
        }
      }
    }
    .main {
      width: 870px;
      margin-top: 10px;
      ul {
        margin-bottom: 50px;
      }
      li {
        display: flex;
        padding: 10px 0;
        border-bottom: 2px solid #ffffff;
        cursor: pointer;
        @media screen and (max-width: 1200px) {
          padding: 30px 0;
        }
      }
      .liL {
        width: 266px;
        height: 130px;
        margin-right: 15px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .liR {
        width: 613px;
        /deep/img {
          width: 0 !important;
          height: 0 !important;
        }
        h4 {
          font-size: 22px;
          color: #e2faff;
          margin-bottom: 20px;
          margin-top: 10px;
          Letter-spacing: 3px
        }
        p {
          font-size: 16px;
          color: #ffffff;
          display: -webkit-box;
          -webkit-box-orient: vertical; /*设置方向*/
          -webkit-line-clamp: 2; /*设置超过为省略号的行数*/
          overflow: hidden;
          display: -moz-box;
          -moz-box-orient: vertical; /*设置方向*/
          -moz-line-clamp: 2; /*设置超过为省略号的行数*/
          box-orient: vertical; /*设置方向*/
          line-clamp: 2; /*设置超过为省略号的行数*/
        }
        .time {
          font-size: 10px;
          text-align: right;
          margin-top: 10px;
        }
      }
    }
  }
}
.el-pagination {
  text-align: center;
}
.null{
  text-align: center;
  color: #ffffff;
  margin-top: 50px;
}
</style>
